import { createSlice } from "@reduxjs/toolkit";

// Define el estado inicial
export const EmptyProductState: number = 3;

export const productSlice = createSlice({
  name: "product",
  initialState: EmptyProductState,
  reducers: {
    setProduct: (state, action) => action.payload, // Define el valor del producto
    resetProduct: () => EmptyProductState, // Resetea el producto a su valor inicial
  },
});

// Exporta las acciones
export const { setProduct, resetProduct } = productSlice.actions;

// Exporta el reducer
export default productSlice.reducer;